import React, { useEffect, useState, useCallback } from "react";
import DashboardLayout from "../../molecules/DashboardLayout";
import { Row, Col, Pagination, Card, Select, message, Typography } from "antd";
import { SectionHeaderV2 } from "../../organism/SectionHeaderV2";
import Grid from "../../atoms/Grid";

import { useSelector, useDispatch } from "react-redux";
import LoaderTsx from "../Loader.tsx";
import { getBookingRenewalForms, sendTenantInvite, updateBookingStatus } from "./ducks/actions";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../../utils/axiosInceptor";
import { baseContractService } from "../../../configs/constants";
import { emptyPropertyUnits, getBookingUnitList, getPropertyUnits } from "../Properties/PropertyDetail/ducks/actions";
import { PopupConfirm } from "../../atoms/Popup";
import { useSearchHistory } from "../../../utils/filterHelper";
import { setFilterBooking } from "../App/SearchFilters/ducks/actions";

import { clearBookingForm } from "../BookingForm/ducks/actions";
import { useBookingRenewalsSearch } from "./hooks";
import { searchByOptions as baseSearchByOptions } from "./constants/searchByOptions";
import { useFeatureToggleSearchByOptions } from "../../../hooks/search";
import { renewalCol, renewalColumn } from "./renewalCol";
import DragAndDropList from "../../atoms/Grid/gridColumnSort";
import { getGridSettings } from "../../../utils/globalService";
import { getOrgByID } from "../../modules/Maintenance/Tickets/ducks/actions";

import { useGridReset } from "../../../hooks/useGridReset";
import { listFilterConfigWithPortfolioUnits } from "../../../utils/helper";
import { BookingFiltersState, FilterOption, useListingFilters } from "../../../hooks/useListingFilters";
import { getPropertiesDrop } from "../Properties/ducks/actions";

const gridProps = {
  resizable: true,
};

const dropDown = [
  { id: 2, name: "Edit", status: "" },
  { id: 3, name: "Send To Tenant", status: "" },
  { id: 4, name: "Cancel", status: "#FB7171" },
];

const dropDownRenewal = [
  { id: 2, name: "Edit", status: "" },
  { id: 4, name: "Cancel", status: "#FB7171" },
];

const dropDown1 = [{ id: 2, name: "Edit", status: "" }];
const dropDown2 = [{ id: 2, name: "View Confirmed Form", status: "" }];
const dropDown3 = [{ id: 4, name: "View Approved Form", status: "" }];

const limit = 50;

const BookingRenewalListing = (props) => {
  const dispatch: any = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [exportData, setExportData] = useState(false);
  const listBookingRenewal = useSelector((state: any) => state.bookingRenewals.bookingRenewalList);
  const propertyList = useSelector((state: any) => state.dashboard.propertiesDrop || []);
  const bookingUnits = useSelector((state: any) => state.propertyDetails.bookingUnitsDropdown || []);
  const portfolioUnits = useSelector((state: any) => state.propertyDetails.unitsDropdown || []);
  const propertyOptions: FilterOption[] = propertyList;
  const [unitLoading, setUnitLoading] = useState(false);

  const listingFilterConfig = useCallback(
    (state: BookingFiltersState) =>
      listFilterConfigWithPortfolioUnits({
        state,
        propertyOptions,
        portfolioUnits,
        bookingUnits,
        portfolioUnitsLoading: unitLoading,
      }),
    [propertyOptions, portfolioUnits, bookingUnits, unitLoading],
  );

  const { viewOption, handleFilterChange, updateValue, filtersState } = useListingFilters<BookingFiltersState>({
    initialState: {
      usagesType: { value: "all", label: "All" },
      property: { value: "all", label: "All" },
      unit: { value: "all", label: "All" },
    },
    configBuilder: listingFilterConfig,
    handlers: {
      property: ({ option, setState, setUpdateValue }) => {
        setState((prev) => ({
          ...prev,
          property: option,
          unit: null,
        }));
        setUpdateValue({ label: "unit", value: null });
        const pid = option?.value;
        if (pid && pid !== "all" && pid !== "") {
          dispatch(getPropertyUnits(pid, null, false, setUnitLoading));
        } else {
          dispatch(getPropertyUnits(null, null, false, setUnitLoading));
        }
      },
    },
    sections: { usagesType: false },
  });

  const filter = useSelector((state: any) => state.filters.bookingsData);
  const [selectedSearchBy, setSelectedSearchBy] = useState(Object.keys(filter)[0] ?? "unitCode");
  const [searchValue, setSearchValue] = useState(filter[Object.keys(filter)[0]] || state?.unitId || "");
  const { searchHistory, addToSearchHistory } = useSearchHistory(setFilterBooking);
  const { selectOptions, handleSearch, handleChangeSearchBy } = useBookingRenewalsSearch({
    selectedSearchBy,
    setSelectedSearchBy,
    setSearchValue,
  });
  const [renewalColumns, setRenewalColumns] = useState(() => [...renewalCol]);
  const [detectColumnChanges, setDetectColumnChanges] = useState(false);
  const organization = useSelector((state: any) => state.tickets.orgData);
  const { resetGrid, setGridReset } = useGridReset();
  useEffect(() => {
    dispatch(getPropertiesDrop());
    dispatch(getPropertyUnits(null, null, false, setUnitLoading));
    return () => {
      dispatch(emptyPropertyUnits());
    };
  }, []);

  useEffect(() => {
    dispatch(clearBookingForm());
  }, []);

  useEffect(() => {
    const buildLeaseColumnsWithKyc = (org) => {
      const kycFields = [...(org?.commercialKycForm || []), ...(org?.residentialKycForm || [])].filter(
        (field, index, self) => index === self.findIndex((f) => f.name === field.name),
      );

      const dynamicKycCols = kycFields.map((field, index) => ({
        id: 47 + index,
        headerName: field.label,
        field: `kycDetails.${field.name}`,
        checked: false,
        hide: true,
      }));

      const mergedLeaseCols = [...renewalCol, ...dynamicKycCols];
      getGridConfig(mergedLeaseCols);
      setRenewalColumns(mergedLeaseCols);
    };

    const init = async () => {
      const isOrgEmpty = !organization || (typeof organization === "object" && Object.keys(organization).length === 0);

      if (isOrgEmpty) {
        const orgData = localStorage?.getItem("login-response");
        const orgId = orgData ? JSON.parse(orgData) : null;
        if (orgId) {
          await dispatch(getOrgByID(orgId?.orgId));
        }
      } else {
        buildLeaseColumnsWithKyc(organization);
      }
    };

    init();
  }, [organization, resetGrid]);

  const getGridConfig = async (columns) => {
    let result = await getGridSettings("renewals", columns, resetGrid);
    if (result?.length) {
      setRenewalColumns(result);
      setGridReset(false);
    }
  };

  const renewalFilterParams = () => ({
    usagesType:
      filtersState.usagesType?.value === "all" || !filtersState.usagesType?.value
        ? ""
        : String(filtersState.usagesType.value),
    propertyId:
      filtersState.property?.value === "all" ||
      filtersState.property?.value === "" ||
      filtersState.property?.value == null
        ? ""
        : filtersState.property.value,
    unitId:
      !filtersState.unit?.value || filtersState.unit?.value === "all" || filtersState.unit?.value === ""
        ? ""
        : filtersState.unit.value,
  });

  const sendToTenant = async (email, leaseId) => {
    if (email && leaseId) {
      let payload = [
        {
          email: email,
          usertype: "tenant",
          leaseId: leaseId,
          inviteAll: false,
        },
      ];
      let successMessage = "Invite sent to tenant successfully";
      const status = await sendTenantInvite(payload, successMessage);
      if (status === 200) {
        message.success(successMessage);
        const res = await updateBookingStatus(leaseId, {
          status: "tenant_invitation_sent",
        });
        if (res === 200) {
          message.success(successMessage);
          setIsLoading(true);
          dispatch(
            getBookingRenewalForms({
              limit,
              page: currentPage,
              value: searchValue,
              field: selectedSearchBy,
              setIsLoading,
              renewalColumns,
              ...renewalFilterParams(),
            }),
          );
        }
      }
    } else {
      message.error("No email id present");
    }
  };

  const handlePagination = (pg) => {
    setCurrentPage(pg);
    setIsLoading(true);

    dispatch(
      getBookingRenewalForms({
        limit,
        page: pg,
        value: searchValue,
        field: selectedSearchBy,
        setIsLoading,
        renewalColumns,
        ...renewalFilterParams(),
      }),
    );
  };

  useEffect(() => {
    setCurrentPage(1);
    addToSearchHistory(selectedSearchBy, searchValue);
    setIsLoading(true);
    dispatch(
      getBookingRenewalForms({
        limit,
        page: 1,
        value: searchValue,
        field: selectedSearchBy,
        exportData,
        totalCount: listBookingRenewal?.totalCount,
        setExportData,
        setIsLoading,
        renewalColumns,
        ...renewalFilterParams(),
      }),
    );
  }, [
    searchValue,
    selectedSearchBy,
    exportData,
    filtersState.usagesType?.value,
    filtersState.property?.value,
    filtersState.unit?.value,
  ]);

  const { searchByOptions } = useFeatureToggleSearchByOptions(baseSearchByOptions);

  useEffect(() => {
    let key = Object.keys(searchHistory)[0];
    if (searchByOptions.length > 0)
      searchByOptions.map((item) => {
        if (key == item.value) item["default"] = true;
        else item["default"] = false;
        return item;
      });
  }, [searchHistory]);

  const MoreAction = (row) => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { Text } = Typography;

    const onChangeHandler = async (e) => {
      if (e === "Cancel") {
        onStatus(row.data.leaseId);
      } else if (e === "Download booking form") {
      } else if (e === "Send To Tenant") {
        if (row.data?.tenantDetails?.email && row.data?.leaseId)
          sendToTenant(row.data.tenantDetails.email, row.data.leaseId);
      } else if (e === "View Confirmed Form") {
        navigate(`/viewbookingform/${row.data.leaseId}`);
      } else if (e === "View Approved Form") {
        navigate(`/viewbookingform/${row.data.leaseId}`);
      } else if (e === "Edit") {
        if (row?.data?.leaseStatus === "draft") navigate(`/newbookingform/${row.data.leaseId}`);
        else navigate(`/viewbookingform/${row.data.leaseId}`);
      } else if (e === "Send for tenant's signature") {
        try {
          let body = {
            leadId: row.data.id,
          };
          await axios.post(`${baseContractService}/booking-form-send-to-prospect`, body);
          message.success("Successfully Sent");
        } catch (e) {
          const { response } = e;
          message.error(response?.data?.message);
        }
      }
    };

    const onStatus = (leaseId) => {
      PopupConfirm({
        title: `Are you sure you want to cancel`,
        onOk: () => onCancelBookingForm(leaseId),
        okText: "Yes",
      });
    };

    const onCancelBookingForm = async (leaseId) => {
      const res = await updateBookingStatus(leaseId, {
        status: "booking_reject",
      });
      if (res === 200) {
        message.success("Booking has been cancelled");
        setIsLoading(true);
        dispatch(
          getBookingRenewalForms({
            limit,
            page: currentPage,
            value: searchValue,
            field: selectedSearchBy,
            setIsLoading,
            renewalColumns,
            ...renewalFilterParams(),
          }),
        );
      }
    };

    return (
      <Select
        onChange={onChangeHandler}
        className="Sentence"
        placeholder="Select an action"
        style={{ width: 150 }}
        allowClear
      >
        <>
          {row.data.leaseStatus === "booking_created" &&
            (row.data.leaseType == "renewal"
              ? dropDownRenewal.map((value, key) => (
                  <React.Fragment key={key}>
                    <Select.Option value={value.name}>
                      <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                    </Select.Option>
                  </React.Fragment>
                ))
              : dropDown.map((value, key) => (
                  <React.Fragment key={key}>
                    <Select.Option value={value.name}>
                      <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                    </Select.Option>
                  </React.Fragment>
                )))}
          {row.data.leaseStatus !== "booking_created" &&
            row.data.leaseStatus !== "booking_confirmed" &&
            row.data.leaseStatus !== "booking_approved" &&
            dropDown1.map((value, key) => (
              <React.Fragment key={key}>
                <Select.Option value={value.name}>
                  <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                </Select.Option>
              </React.Fragment>
            ))}
          {row.data.leaseStatus === "booking_confirmed" &&
            dropDown2.map((value, key) => (
              <React.Fragment key={key}>
                <Select.Option value={value.name}>
                  <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                </Select.Option>
              </React.Fragment>
            ))}
          {row.data.leaseStatus === "booking_approved" &&
            dropDown3.map((value, key) => (
              <React.Fragment key={key}>
                <Select.Option value={value.name}>
                  <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                </Select.Option>
              </React.Fragment>
            ))}
        </>
      </Select>
    );
  };

  //  for export data and send in email
  const exportAction = () => {
    setExportData(true);
  };

  return (
    <DashboardLayout>
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <SectionHeaderV2
                heading="Renewals in Progress"
                total={listBookingRenewal?.totalCount || 0}
                downloadAction={exportAction}
                propertyAdminOptions={true}
                onSearch={handleSearch}
                onChangeSearchBy={handleChangeSearchBy}
                defaultSearch={searchValue}
                searchByOptions={searchByOptions}
                selectOptions={selectOptions}
                justifiedItems={true}
                justifyEnd={true}
                viewOption={viewOption}
                handleView={handleFilterChange}
                updateValue={updateValue}
                filterStyle={{ marginRight: "10px" }}
              />
            </Col>
            <Col span={23}>
              <Pagination
                className="ag-property-text-pagination"
                total={listBookingRenewal?.totalCount || 0}
                showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} bookings`}
                defaultPageSize={50}
                defaultCurrent={1}
                showSizeChanger={false}
                current={currentPage}
                onChange={(e) => handlePagination(e)}
              />
            </Col>
            <Col span={1}>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <DragAndDropList
                  columns={renewalColumns}
                  setModifiedColumns={setRenewalColumns}
                  changePicker={setDetectColumnChanges}
                  detectColumnChanges={detectColumnChanges}
                  screenName="renewals"
                  setGridReset={setGridReset}
                />
              </div>
            </Col>
            <Col span={24}>
              <Row gutter={[24, 24]} justify="end">
                <Col span={24}>
                  <Card bordered={false} className="ag-nospace-body">
                    {isLoading ? (
                      <LoaderTsx />
                    ) : (
                      <Grid
                        refCol="status"
                        data={listBookingRenewal?.data ?? []}
                        columns={renewalColumn(renewalColumns, MoreAction, props)}
                        autoSizeColumns={true}
                        pagination={false}
                        defaultSettings={gridProps}
                        noRowlabel="Bookings"
                        fullPage={true}
                      />
                    )}
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </DashboardLayout>
  );
};

export default BookingRenewalListing;
